export const SwapMode = {
    ExactInOrOut: 'ExactInOrOut',
    ExactIn: 'ExactIn',
    ExactOut: 'ExactOut',
  } as const;